import {Component, Inject, OnInit} from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ApiRequestService } from "../../services/api-request.service";
import {Router,Params, ActivatedRoute} from "@angular/router";
import {AppConfigService} from "../../app-config.service";
import {MsalAuthService} from "../../services/msal-auth.service";
import {ConversationStoreService} from "../../services/conversation-store.service";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

    private window;
    private interval_1: any;

    constructor(
        @Inject('Window') window: Window,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private apiService: ApiRequestService,
        private appConfig: AppConfigService,
        private msal: MsalAuthService,
        private conversationStore: ConversationStoreService
    ) {
        this.window = window;
    }
    ngOnDestroy() {
        clearInterval( this.interval_1 );
        sessionStorage.clear();
    }
    ngOnInit(): void {
        this.apiService.logout().subscribe( {
            complete: () => {
            }, error: () => {
            }
        } );
        this.userService.logout();
        sessionStorage.clear();
        this.conversationStore.clearOverrides();
        this.conversationStore.clearCache();
        // console.log( "LOGOUT !! ");
        if ( this.msal.getHasActiveAccount() ) {
            // console.log('FLAG');
            this.msal.logout();
        }

        let me = this;
        this.activatedRoute.queryParams.subscribe({
            next: (params: Params) => {
                me.interval_1 = setTimeout( () => {
                    me.casLogout(params);
                }, 2000 );
            },
            error: (err: Error) => console.error('Observer got an error: ' + err),
            complete: () => {
           }
        });
        // me.window.location.href = me.casLogoutUrl;
        // me.router.navigate(["/login"]);
    }
    public get casLogoutUrl() {
        return this.appConfig.getCasUrl() + "/logout?url=" + this.appConfig.getAppUrl();
    }
    public casLogout( params:Params ) {
        let url = this.casLogoutUrl;
        let path: string = "";
        // console.log( 'LOGOUT: ', params );
        // DO NOT include '/logout'
        if ( params['channel'] != undefined && params['channel'] != '' && params['channel'] != 'logout') {
            url = url + "?channel="+params['channel'];
        } else {
            url = url + "";
        }
        // console.log( 'LOGOUT: ' + url );
        this.window.location.href = url;
        // this.router.navigate(["/"]);
    }
}
